// extracted by mini-css-extract-plugin
module.exports = {"cardStatus":"status_cardStatus__2MqbZ","statusBlock":"status_statusBlock__1dZxd"};